import Xt from "../models/backend-errors.js";
import ve from "../models/braze-event.js";
import {
  convertMsToSeconds as O,
  convertSecondsToMs as $t,
} from "../util/date-utils.js";
import c from "../common/event-logger.js";
import { isArray as z, isEqual as ii } from "../util/code-utils.js";
import { logger as N, EventTypes as d } from "../../shared-lib/index.js";
import { STORAGE_KEYS as s } from "./storage-manager.js";
import h from "../util/request-header-utils.js";
import {
  LAST_REQUEST_TO_ENDPOINT_MS_AGO_DEFAULT as Kt,
  MAX_RETRY_COUNT_PER_REQUEST as Ht,
} from "../common/constants.js";
import { getAlias as Yt } from "./utils.js";
import { readResponseHeaders as Jt } from "../util/net.js";
export default class Pt {
  constructor(t, e, i, s, r, n, o, a, h, u, l, c) {
    (this.hn = t),
      (this.C = e),
      (this.Pa = i),
      (this.Cs = s),
      (this.T = r),
      (this.B = n),
      (this.an = o),
      (this.La = a),
      (this.Ta = h),
      (this.Ra = u),
      (this.appVersion = l),
      (this.au = c),
      (this.du = (t) => (null == t ? "" : `${t} `)),
      (this.hn = t),
      (this.C = e),
      (this.Pa = i),
      (this.Cs = s),
      (this.T = r),
      (this.B = n),
      (this.an = o),
      (this.La = a),
      (this.Ta = h),
      (this.Ra = u),
      (this.appVersion = l),
      (this.au = c),
      (this.fu = ["npm"]),
      (this.vu = []);
  }
  H(t, e = !1, i = !1) {
    const r = this.hn.ve(!i),
      n = r.Nr(),
      o = this.C.ft(s.gt.oc);
    ii(o, n) || (t.device = n),
      (t.api_key = this.an),
      (t.time = O(new Date().valueOf(), !0));
    const a = this.C.ft(s.gt.pu) || [],
      h = this.C.ft(s.gt.Ru) || "";
    this.fu.length > 0 &&
      (!ii(a, this.fu) || h !== this.T.St()) &&
      (t.sdk_metadata = this.fu),
      (t.sdk_version = this.Ta),
      this.Ra && (t.sdk_flavor = this.Ra),
      (t.app_version = this.appVersion),
      (t.app_version_code = this.au),
      (t.device_id = r.id);
    const u = this.Cs.getUserId();
    if ((e && null !== u && (t.user_id = u), !u && !this.Pa.jh())) {
      const e = Yt(this.C);
      e && (t.alias = e);
    }
    return t;
  }
  st(t, e, i) {
    const s = e.auth_error,
      r = e.error;
    if (!s && !r) return !0;
    if (s) {
      let e;
      this.Pa.Jh();
      const r = { errorCode: s.error_code };
      for (const t of i)
        z(t) && "X-Braze-Auth-Signature" === t[0] && (r.signature = t[1]);
      t.respond_with && t.respond_with.user_id
        ? (r.userId = t.respond_with.user_id)
        : t.user_id && (r.userId = t.user_id);
      const n = s.reason;
      return (
        n
          ? ((r.reason = n), (e = `due to ${n}`))
          : (e = `with error code ${s.error_code}.`),
        this.Pa.jh() ||
          (e +=
            ' Please use the "enableSdkAuthentication" initialization option to enable authentication.'),
        N.error(`SDK Authentication failed ${e}`),
        this.gu(t.events || [], t.attributes || []),
        this.Pa.Gh(r),
        !1
      );
    }
    if (r) {
      let i,
        s = r;
      switch (s) {
        case Xt.bu:
          return (
            (i = "Received successful response with empty body."),
            c.ut(d.qu, { e: i }),
            N.info(i),
            !1
          );
        case Xt.Au:
          return (
            (i = "Received successful response with invalid JSON"),
            c.ut(d.qu, { e: i + ": " + e.response }),
            N.info(i),
            !1
          );
        case Xt.Du:
          s = `The API key "${t.api_key}" is invalid for the baseUrl ${this.La}`;
          break;
        case Xt.Tu:
          s =
            "Sorry, we are not currently accepting your requests. If you think this is in error, please contact us.";
          break;
        case Xt.ku:
          s = "No device identifier. Please contact support@braze.com";
      }
      N.error("Backend error: " + s);
    }
    return !1;
  }
  yu(t, e, i, s) {
    return !!((t && 0 !== t.length) || (e && 0 !== e.length) || i || s);
  }
  wu(t, e, i, s, r = !1) {
    const n = [],
      o = (t) => t || "",
      a = o(this.Cs.getUserId());
    let u = this.Gr(t, e);
    const l = [],
      c = [];
    let d,
      f = null;
    if (i.length > 0) {
      const t = [];
      for (const e of i) {
        if (((d = e.Nr()), this.Pa.jh())) {
          if (a && !d.user_id) {
            f || (f = {}), f.events || (f.events = []), f.events.push(d);
            continue;
          }
          if (o(d.user_id) !== a) {
            c.push(d);
            continue;
          }
        }
        t.push(d);
      }
      t.length > 0 && (u.events = t);
    }
    if (s.length > 0) {
      const t = [];
      for (const e of s)
        e && (this.Pa.jh() && o(e.user_id) !== a ? l.push(e) : t.push(e));
      t.length > 0 && (u.attributes = t);
    }
    if ((this.gu(c, l), (u = this.H(u, !1, r)), f)) {
      f = this.H(f, !1, r);
      const t = { requestData: f, headers: this.J(f, h.O.Nu) };
      n.push(t);
    }
    if (u && !this.yu(u.events, u.attributes, t, e)) return f ? n : null;
    const m = { requestData: u, headers: this.J(u, h.O.Nu) };
    return n.push(m), n;
  }
  gu(t, e) {
    if (t) {
      const e = [];
      for (const i of t) {
        const t = ve.fromJson(i);
        (t.time = $t(t.time)), e.push(t);
      }
      this.C.Vo(e);
    }
    if (e) for (const t of e) this.C.Cu(t);
  }
  et(t, e) {
    let i = "HTTP error ";
    null != t && (i += t + " "), (i += e), N.error(i);
  }
  zr(t) {
    return c.ut(d.Su, { n: t });
  }
  Gr(t, e, i) {
    const s = {};
    t && (s.feed = !0), e && (s.triggers = !0);
    const r = null != i ? i : this.Cs.getUserId();
    if ((r && (s.user_id = r), !s.user_id && !this.Pa.jh())) {
      const t = Yt(this.C);
      t && (s.alias = t);
    }
    return (s.config = { config_time: this.B.Et() }), { respond_with: s };
  }
  Bu(t) {
    const e = new Date().valueOf();
    let i = Kt.toString();
    const s = h.zu(this.C, t);
    if (-1 !== s) {
      i = (e - s).toString();
    }
    return i;
  }
  J(t, e, i = !1) {
    const s = [["X-Braze-Api-Key", this.an]],
      r = this.Bu(e);
    s.push(["X-Braze-Last-Req-Ms-Ago", r]);
    const n = h.ju(this.C, e).toString();
    s.push(["X-Braze-Req-Attempt", n]);
    let o = !1;
    if (
      (null != t.respond_with &&
        t.respond_with.triggers &&
        (s.push(["X-Braze-TriggersRequest", "true"]), (o = !0)),
      null != t.respond_with &&
        t.respond_with.feed &&
        (s.push(["X-Braze-FeedRequest", "true"]), (o = !0)),
      e === h.O.wi)
    ) {
      s.push(["X-Braze-ContentCardsRequest", "true"]);
      let t = h.ju(this.C, h.O.wi);
      (t && !i) || ((t = 1), h.Mu(this.C, h.O.wi, t));
      const e = Math.max(0, t - 1);
      s.push(["BRAZE-SYNC-RETRY-COUNT", e.toString()]), (o = !0);
    }
    if (
      (e === h.O.Le &&
        (s.push(["X-Braze-FeatureFlagsRequest", "true"]), (o = !0)),
      o && s.push(["X-Braze-DataRequest", "true"]),
      this.Pa.jh())
    ) {
      const t = this.Pa.xh();
      null != t && s.push(["X-Braze-Auth-Signature", t]);
    }
    return s;
  }
  Xu(t, e, i, s) {
    const r = window.setTimeout(() => {
      N.info(`Retrying rate limited ${this.du(s)}SDK request.`),
        this.V(e, i, s);
    }, t);
    this.vu.push(r);
  }
  fo() {
    for (const t of this.vu) window.clearTimeout(t);
    this.vu = [];
  }
  V(t, e, i, r) {
    if (!this.$u(i))
      return (
        N.info(`${this.du(i)}SDK request being rate limited.`),
        void ("function" == typeof r && r())
      );
    const n = this.Fu();
    if (!n.Lu)
      return (
        N.info(
          `${this.du(
            i,
          )}SDK request being rate limited. Request will be retried in ${Math.trunc(
            n.Eu / 1e3,
          )} seconds.`,
        ),
        void this.Xu(n.Eu, t, e, i)
      );
    this.C.Bt(s.gt.Ku, new Date().valueOf());
    const o = t.device;
    o && o.os_version instanceof Promise
      ? o.os_version.then((i) => {
          (t.device.os_version = i), e(n.Iu);
        })
      : e(n.Iu);
  }
  Pu(t) {
    const e = t ? Jt(t) : null;
    if (!e || !e["retry-after"]) return null;
    const i = e["retry-after"];
    if (isNaN(i) && !isNaN(Date.parse(i)))
      return { type: "date", value: Date.parse(i) };
    if (!isNaN(parseFloat(i.toString())))
      return { type: "timestamp", value: 1e3 * parseFloat(i.toString()) };
    {
      const t =
        "Received unexpected value for retry-after header in /sync response";
      c.ut(d.qu, { e: t + ": " + i });
    }
    return null;
  }
  rt(t, e, i, s, r, n) {
    if (h.ju(this.C, i) >= Ht) return;
    let o;
    n = n || 0;
    const a = this.Pu(t);
    r();
    const u = (t) => {
      const r = window.setTimeout(() => {
        e();
      }, t);
      s(r), h.Uu(this.C, i);
    };
    if (a && !isNaN(a.value)) {
      switch (a.type) {
        case "date":
          (o = a.value - new Date().getTime() + n), o < 0 && e();
          break;
        case "timestamp":
          o = a.value + n;
      }
      u(o);
    } else n ? u(n) : h.vi(this.C, i);
  }
  xu(t) {
    var e;
    null === (e = this.C) || void 0 === e || e.Bt(s.gt.Hu, t);
  }
  Ou(t, e) {
    let i = this.Gu();
    null == i && (i = {}), (i[t] = e), this.C.Bt(s.gt._u, i);
  }
  Wu() {
    var t;
    return null === (t = this.C) || void 0 === t ? void 0 : t.ft(s.gt.Hu);
  }
  Gu() {
    var t;
    return null === (t = this.C) || void 0 === t ? void 0 : t.ft(s.gt._u);
  }
  Yu(t, e, i, s, r = "") {
    let n;
    if (r) {
      const t = this.Gu();
      n = null == t || isNaN(t[r]) ? e : t[r];
    } else (n = this.Wu()), (null == n || isNaN(n)) && (n = e);
    const o = (t - s) / 1e3;
    return (n = Math.min(n + o / i, e)), n;
  }
  Ju(t, e) {
    return Math.max(0, (1 - t) * e * 1e3);
  }
  Qu(t, e = "") {
    var i, r, n, o, a;
    const u = { Lu: !0, Iu: -1, Eu: 0 };
    if ((null == t && (t = !0), !t && !e)) return u;
    let l,
      c,
      d = null;
    if (t) d = null === (i = this.C) || void 0 === i ? void 0 : i.ft(s.gt.Ku);
    else {
      const t = h.Vu(this.C);
      if (null == t || null == t[e]) return u;
      d = t[e];
    }
    if (null == d || isNaN(d)) return u;
    if (
      (t
        ? ((l =
            (null === (r = this.B) || void 0 === r ? void 0 : r.Zu()) || -1),
          (c = (null === (n = this.B) || void 0 === n ? void 0 : n.tl()) || -1))
        : ((l =
            (null === (o = this.B) || void 0 === o ? void 0 : o.el(e)) || -1),
          (c =
            (null === (a = this.B) || void 0 === a ? void 0 : a.il(e)) || -1)),
      -1 === l || -1 === c)
    )
      return u;
    const f = new Date().valueOf();
    let m = this.Yu(f, l, c, d, e);
    return m < 1
      ? ((u.Lu = !1), (u.Eu = this.Ju(m, c)), u)
      : ((m = Math.trunc(m) - 1),
        (u.Iu = m),
        t ? this.xu(m) : this.Ou(e, m),
        u);
  }
  Fu() {
    return this.Qu(!0);
  }
  $u(t) {
    const e = this.Qu(!1, t);
    return !(e && !e.Lu);
  }
  it() {
    this.Pa.it();
  }
  Z() {
    return this.La;
  }
  addSdkMetadata(t) {
    for (const e of t) -1 === this.fu.indexOf(e) && this.fu.push(e);
  }
}
